<template>
  <div>
    <div v-if="loading">
      <MoonLoader class="loading"></MoonLoader>
    </div>

    <div v-else>
      <div class="row">
        <div class="col text-center">
          <h2>Vivid Leaf statistics for {{ company.name }}</h2>
        </div>
      </div>

      <div class="row"></div>
      <PublicSidebar
        :prop_categories="categories"
        :current-page="currentPage"
        @pageChanged="showNewPage($event)"
        :token="token"
      />

      <div class="row"></div>

      <div v-if="currentPage === 'Summary' && summary" class="row">
        <div class="col-xl-3">
          <div class="row">
            <div class="w-full">
              <DashboardElementTotal
                :summary="summary"
                :questionnaireScoreByColor="questionnaireScoreByColor"
              ></DashboardElementTotal>
            </div>
          </div>
        </div>
        <div class="col-xl-9">
          <div class="row">
            <div class="col-md-6 col-lg-4" v-for="(element, index) in summary" :key="index">
              <DashboardElementSummary :summary="element"></DashboardElementSummary>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <PublicCategoryPage :company="company" :category="selectedCategory"></PublicCategoryPage>
      </div>
    </div>

    <div class="row">
      <div class="col text-center">
        <h4>Powered by <a href="https://vivid-leaf.net" target="_blank" class="website">Vivid Leaf</a></h4>
      </div>
    </div>
  </div>
</template>

<script>
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import DashboardElementTotal from '@/components/Dashboard/DashboardElementTotal';
import DashboardElementSummary from '@/components/Dashboard/DashboardElementSummary';
import PublicDashboardSummaryController from '@/controllers/PublicData/PublicDashboardSummaryController';
import UpperSidebar from '@/components/SidebarPlugin/UpperSidebar';
import PublicCategoriesController from '@/controllers/PublicData/PublicCategoriesController';
import PublicSidebar from '@/components/SidebarPlugin/PublicSidebar';
import PublicCategoryPage from '@/pages/API/Public/Dashboard/PublicCategoryPage';
import PublicCompanyDataController from '@/controllers/PublicData/PublicCompanyDataController';
import GenerateDashboardTokenController from '@/controllers/PublicData/GenerateDashboardTokenController';
import PublicUpperSidebarLink from '@/components/SidebarPlugin/PublicUpperSidebarLink';

export default {
  name: 'PublicDashboard',
  components: {
    PublicUpperSidebarLink,
    PublicCategoryPage,
    PublicSidebar,
    UpperSidebar,
    DashboardElementSummary,
    DashboardElementTotal,
    MoonLoader,
  },
  data() {
    return {
      company: null,
      loading: false,
      summary: null,
      questionnaireScoreByColor: null,
      categories: null,
      currentPage: '',
      selectedCategory: null,
      token: null,
    };
  },
  async mounted() {
    this.loading = true;
    await this.getToken();
    await this.getCompany();
    await this.getCategories();
    await this.getSummary();
    this.loading = false;
  },
  methods: {
    async getSummary() {
      try {
        if (this.token && this.token.scopes.includes('read_summary_data')) {
          let result = await PublicDashboardSummaryController.index();
          this.summary = result.summary;
          this.questionnaireScoreByColor = this.getTotalQuestionnaireScoreByColor(result.summary);
          this.currentPage = 'Summary';
        } else {
          this.selectFirstCategory();
        }
      } catch (e) {
        console.error(e);
      }
    },
    getTotalQuestionnaireScoreByColor(summary) {
      let green = 0;
      let yellow = 0;
      let red = 0;
      let grey = 0;

      summary.forEach((element) => {
        grey += element.grey;
        red += element.red;
        yellow += element.yellow;
        green += element.green;
      });

      let total = green + yellow + red + grey;

      let green_percent = Math.round((green / total) * 100);
      let yellow_percent = Math.round((yellow / total) * 100);
      let red_percent = Math.round((red / total) * 100);
      let grey_percent = Math.round((grey / total) * 100);

      return {
        labels: [green_percent + '%', yellow_percent + '%', red_percent + '%', grey_percent + '%'],
        series: [green_percent, yellow_percent, red_percent, grey_percent],
      };
    },
    async getCategories() {
      this.categories = await PublicCategoriesController.index();
    },
    showNewPage(newPage) {
      this.currentPage = newPage.name;
      if (newPage.category) this.selectedCategory = newPage.category;
    },
    async getToken() {
      this.token = await GenerateDashboardTokenController.show();
    },
    async getCompany() {
      this.company = await PublicCompanyDataController.index();
    },
    selectFirstCategory() {
      if (this.token && this.token.scopes.length > 0) {
        if (this.token.scopes.includes('read_energy_data')) {
          this.selectedCategory = this.categories.find((category) => {
            return (category.name = 'energy');
          });
          this.currentPage = 'energy';
        } else if (this.token.scopes.includes('read_environment_data')) {
          this.selectedCategory = this.categories.find((category) => {
            return category.name === 'environment';
          });
          this.currentPage = 'environment';
        } else if (this.token.scopes.includes('read_waste_data')) {
          this.selectedCategory = this.categories.find((category) => {
            return category.name === 'waste';
          });
          this.currentPage = 'waste';
        } else if (this.token.scopes.includes('read_read_water_data_data')) {
          this.selectedCategory = this.categories.find((category) => {
            return category.name === 'water';
          });
          this.currentPage = 'water';
        } else if (this.token.scopes.includes('read_air_data')) {
          this.selectedCategory = this.categories.find((category) => {
            return category.name === 'air';
          });
          this.currentPage = 'air';
        } else if (this.token.scopes.includes('read_policies_data')) {
          this.selectedCategory = this.categories.find((category) => {
            return category.name === 'education and policies';
          });
          this.currentPage = 'education and policies';
        }
      }
    },
  },
};
</script>

<style scoped></style>
